import { createAction } from 'redux-act';

/**
 * Create action
 */

const completeInitialisation = createAction('INITIALISATION_COMPLETE');

export default completeInitialisation;
